import { Button } from "@/components/ui/button";

interface FormActionsProps {
  isSubmitting?: boolean;
  onCancel?: () => void;
}

export const FormActions = ({ isSubmitting, onCancel }: FormActionsProps) => {
  return (
    <div className="flex justify-end space-x-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={onCancel}
        className="transition-transform hover:scale-105"
      >
        Cancel
      </Button>
      <Button 
        type="submit" 
        disabled={isSubmitting}
        className={`transition-transform hover:scale-105 ${isSubmitting ? 'animate-pulse' : ''}`}
      >
        {isSubmitting ? 'Saving...' : 'Save Changes'}
      </Button>
    </div>
  );
};